module.exports = __webpack_public_path__ + "img/bu-image-2x.f9df8c8e.jpg";